export default (key, results, fn = f => f) => {
  return (
    (results &&
      results.reduce((aggregationResults, result) => {
        const valueKey = fn(result[key]).toLowerCase()
        if (!valueKey) return aggregationResults
        if (!aggregationResults[valueKey]) aggregationResults[valueKey] = 0
        aggregationResults[valueKey] += 1
        return aggregationResults
      }, {})) ||
    {}
  )
}
